/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export enum Brands {
  MAYORAL = 'mayoral',
  BOSTON = 'boston',
  HUGANDCLAU = 'hugandclau',
  ABELANDLULA = 'abelandlula',
}

export enum BrandInitials {
  MAYORAL = 'M',
  ABELANDLULA = 'A',
  BOSTON = 'B',
  HUGANDCLAU = 'H',
}

function resolveBrand(): Brands {
  const brandFromEnv = String(process.env.BRAND).toUpperCase();
  if (brandFromEnv in Brands) {
    return Brands[brandFromEnv];
  }
  return Brands.MAYORAL;
}

export const Brand = resolveBrand();
